import { OtherEnum } from '@/types/translations/OtherEnum';
import { object, string } from 'yup';

const validatePressReleaseSignupSchema = (translate: (key: OtherEnum) => string) =>
  object().shape({
    email: string()
      .email(translate(OtherEnum['press.validation.email_invalid']))
      .required(translate(OtherEnum['press.validation.email_required'])),
  });

function validatePressReleaseSignup(email: string, translate: (key: OtherEnum) => string) {
  const schema = validatePressReleaseSignupSchema(translate);
  try {
    schema.validateSync({ email });
    return {};
  } catch (error: any) {
    return { email: error.message };
  }
}

export { validatePressReleaseSignup };
